import { render, staticRenderFns } from "./PostFeaturedPreview.vue?vue&type=template&id=6500c2e1&scoped=true&"
import script from "./PostFeaturedPreview.vue?vue&type=script&lang=js&"
export * from "./PostFeaturedPreview.vue?vue&type=script&lang=js&"
import style0 from "./PostFeaturedPreview.vue?vue&type=style&index=0&id=6500c2e1&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6500c2e1",
  null
  
)

export default component.exports